import { PrimaryButton } from "../components/CustomButton";
import { If } from "../components/If";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";

export interface GenerateCurtailmentObjectsModalActionsProps {
	onClose: () => void;
	onSkip?: () => void;
	submitForm: () => void;
	resetForm: () => void;
}

export function GenerateCurtailmentObjectsModalActions(
	props: Readonly<GenerateCurtailmentObjectsModalActionsProps>
) {
	return (
		<>
			<PrimaryButton
				onClick={() => {
					props.onClose();
					props.resetForm();
				}}
				text="Cancel"
				type="button"
				color="secondary"
			/>
			<If condition={props.onSkip}>
				<PrimaryButton
					onClick={() => {
						props.onSkip?.();
						props.resetForm();
					}}
					text="Skip"
					type="button"
					color="secondary"
				/>
			</If>
			<PrimaryButton
				onClick={() => {
					props.submitForm();
				}}
				text="Generate"
				type="button"
				color="primary"
				startIcon={<AddCircleOutlineOutlinedIcon />}
			/>
		</>
	);
}
